import { esDiningRoomPalettes } from "../../../../Posts/05-tematicas/02-sala-de-comedor/diningRoomPalettes.js";
import { localizeTematicPalettes } from "../../../../src/helpers/localizeTematicPalettes.js";
import * as React from 'react';
export default {
  esDiningRoomPalettes,
  localizeTematicPalettes,
  React
};